import { render } from "./StockIndex.vue?vue&type=template&id=60f87bed"
import script from "./StockIndex.vue?vue&type=script&lang=js"
export * from "./StockIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__